import * as React from 'react';

import { agentLayoutStyles } from './agent-page.styles';

interface AgentLayoutProps {
    header?: React.ReactNode;
    sidebar?: React.ReactNode;
    content: React.ReactNode;
    className?: string;
}

export const AgentLayout: React.FC<AgentLayoutProps> = ({ header, sidebar, content, className }) => {
    return (
        <div css={agentLayoutStyles} className={className}>
            {header}
            <div className="agent-layout__body">
                {sidebar}
                <div className="agent-layout__content">{content}</div>
            </div>
        </div>
    );
};
